/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { STATUS } from 'sarsaparilla';

import {
    FETCH_REVIEW_SUMMARY_SUCCESS,
    FETCH_REVIEW_SUMMARY_ERROR,
    SET_FETCH_REVIEW_SUMMARY_STATUS,
} from '../actions/reviewSummaryActions';

export const initialState = {
    loadingStatus: STATUS.PENDING,
    isLoading: true,
    facilityId: null,
    rating: null,
    mobileCoverageRating: null,
};

export const reviewSummaryReducers = (state = initialState, action) => {
    switch (action.type) {
        case SET_FETCH_REVIEW_SUMMARY_STATUS:
            return {
                ...state,
                loadingStatus: action.payload,
            };
        case FETCH_REVIEW_SUMMARY_SUCCESS: {
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                loadingStatus: STATUS.SUCCESS,
            };
        }

        case FETCH_REVIEW_SUMMARY_ERROR:
            return {
                ...state,
                error: action.payload,
                isLoading: false,
                loadingStatus: STATUS.ERROR,
            };
        default:
            return state;
    }
};
